import { IMenuActivity } from '../Menu/Store/IMenuActivity'
import { IMenuCategory } from '../Menu/Store/IMenuCategory'
import { IActivityCategory, IExtraActivity } from '../ExtraActivity/Client/IExtraActivity'
import { IPerson } from '../SelectPerson/interface/IPerson'
import { ICustomer } from '../Appointment/store/interface/IAppointmentState'
import { BookingRestoreState } from './types'

export function findMenuActivity(
  categories: IMenuCategory[],
  activityId: number,
  categoryId?: number,
): IMenuActivity | null {
  for (const category of categories) {
    if (category.activities) {
      const found = category.activities.find((a) => a.id === activityId)
      if (found) {
        return {
          ...found,
          categoryId: categoryId ?? category.id,
          type: 'menuActivity',
        }
      }
    }
    if (category.categories) {
      const found = findMenuActivity(category.categories, activityId, categoryId)
      if (found) return found
    }
  }
  return null
}

export function findMenuCategory(
  categories: IMenuCategory[],
  categoryId: number,
): IMenuCategory | null {
  for (const category of categories) {
    if (category.id === categoryId) return category
    if (category.categories) {
      const found = findMenuCategory(category.categories, categoryId)
      if (found) return found
    }
  }
  return null
}

export function findExtraActivity(
  activityCategories: IActivityCategory[],
  activityId: number,
): IExtraActivity | null {
  for (const category of activityCategories) {
    const found = category.activities.find((a) => a.id === activityId)
    if (found) return found
  }
  return null
}

export function resolveActivities(
  restoreState: BookingRestoreState,
  menuCategories: IMenuCategory[],
  extraActivities: IActivityCategory[],
  persons: IPerson[],
): ICustomer[] | null {
  const customers: ICustomer[] = []

  for (const customer of restoreState.customers) {
    const activities: IMenuActivity[] = []

    for (const restoreActivity of customer.activities) {
      let resolved: IMenuActivity | null = null

      if (restoreActivity.type === 'menuActivity') {
        resolved = findMenuActivity(
          menuCategories,
          restoreActivity.id,
          restoreActivity.categoryId,
        )
      } else {
        const extra = findExtraActivity(extraActivities, restoreActivity.id)
        if (extra) {
          resolved = {
            id: extra.id,
            uuid: extra.uuid,
            name: extra.name,
            description: extra.description,
            image: extra.image ?? '',
            order: extra.order,
            duration: extra.duration ?? 0,
            waitTime: extra.waitTime,
            price: extra.price,
            deposit: extra.deposit,
            isPersonSelectable: extra.isPersonSelectable,
            type: 'activity',
            menuId: 0,
            isFirstOfMenu: false,
          }
        }
      }

      if (!resolved) return null

      if (restoreActivity.personId) {
        const person = persons.find((p) => p.id === restoreActivity.personId)
        if (person) {
          resolved = { ...resolved, personSelected: person }
        }
      }

      activities.push(resolved)
    }

    customers.push({ activities })
  }

  return customers
}
